import { HasFormValue } from 'app/common/input/HasFormValue';
import { InputNumber } from 'antd';
import React from 'react';
import TimeUtils from 'app/common/util/TimeUtils';
import Utils from 'app/common/util/Utils';

export interface InputDurationProps extends HasFormValue<number> {
    disabled?: boolean;
}

/**
 * InputDuration - the value is expected in milliseconds (as is often the case in DTOs), but displayed in minutes.
 * Also the value of -1 is interpreted as 'undefined'
 */
export class InputDuration extends React.PureComponent<InputDurationProps> {
    onChange = (value: number) => {
        this.props.onChange?.(toDuration(value));
    };

    render() {
        return (
            <InputNumber
                disabled={this.props.disabled}
                min={0}
                value={toInputValue(this.props.value)}
                onChange={this.onChange}
                style={{ width: '5em' }}
            />
        );
    }
}

function toDuration(value: number) {
    if (Utils.isExists(value)) {
        return value * TimeUtils.MIN_TO_MS;
    } else {
        return -1;
    }
}

function toInputValue(value: number) {
    if (Utils.isExists(value)) {
        return value === -1 ? undefined : value / TimeUtils.MIN_TO_MS;
    }
}
